export default "__VITE_ASSET__BsMNXpHU__"